<script>
import { mapActions } from "vuex";

export default {
   name: "login",
   data() {
      return {
         user: {
            username: "",
            password: "",
         },
         type: "password",
         username: "",
         passwordjwt: "",
         submitted: false,
         loading: false,
      };
   },
   computed: {},
   created() {
      if (this.$store.state.auth.status.loggedIn) {
         this.$router.push("/dashboard");
      }
   },
   methods: {
      ...mapActions({
         reset: "menu/resetMenu",
         getLingkunganStasi: "service/getLingkunganStasi",
      }),
      // JWT authentication
      handleSubmit() {
         this.submitted = true;
         this.loading = true;

         if (this.user.username && this.user.password) {
            this.$store.dispatch("auth/login", this.user).then(
               (response) => {
                  // RESET MENU ITEM
                  this.reset(response);
                  this.getLingkunganStasi();
                  this.$router.push("/dashboard");
               },
               () => {
                  this.loading = false;
               }
            );
         } else {
            this.loading = false;
         }

         const { username, passwordjwt } = this;
         const { dispatch } = this.$store;
         if (username && passwordjwt) {
            dispatch("authentication/login", { username, passwordjwt });
         }
      },
      // show/hide password
      showPassword: function () {
         if (this.type === "password") {
            this.type = "text";
         } else {
            this.type = "password";
         }
      },

      landingPage() {
         this.$router.push("/");
      },
   },
};
</script>

<template>
   <div>
      <!-- page-wrapper Start-->
      <div class="container-fluid p-0">
         <div class="row m-0">
            <div class="col-12 p-0">
               <div class="login-card">
                  <div>
                     <div>
                        <a class="logo">
                           <img class="img-fluid for-light" src="../assets/images/logo/login.png" alt="looginpage" />
                           <img class="img-fluid for-dark" src="../assets/images/logo/logo_dark.png" alt="looginpage" />
                        </a>
                     </div>
                     <div class="login-main">
                        <b-card no-body>
                           <b-tabs pills vertical>
                              <b-tab>
                                 <template #title>
                                    <img src="../assets/images/login/jwt.svg" />
                                    <span>JWT</span>
                                 </template>
                                 <b-card-text>
                                    <form class="theme-form" @submit.prevent="handleSubmit">
                                       <div class="form-group">
                                          <label for="username">Username</label>
                                          <input type="text" v-model="user.username" name="username"
                                             class="form-control" :class="{
                                                'is-invalid':
                                                   submitted && !user.username,
                                             }" />
                                          <div v-show="submitted && !user.username" class="invalid-feedback">
                                             Username is required
                                          </div>
                                       </div>
                                       <div class="form-group">
                                          <label htmlFor="password">Password</label>
                                          <input type="password" v-model="user.password" name="password"
                                             class="form-control" :class="{
                                                'is-invalid':
                                                   submitted && !user.password,
                                             }" />
                                          <div v-show="submitted && !user.password
                                             " class="invalid-feedback">
                                             Password is required
                                          </div>
                                       </div>
                                       <div class="form-group mt-3 mb-0">
                                          <button class="btn btn-primary btn-block">
                                             <span v-show="loading" class="spinner-border spinner-border-sm"></span>
                                             Login
                                          </button>
                                       </div>
                                    </form>

                                    <div class="form-group mt-3 mb-0">
                                       <button class="btn btn-dark btn-block" @click="landingPage">
                                          Beranda
                                       </button>
                                    </div>
                                 </b-card-text>
                              </b-tab>
                           </b-tabs>
                        </b-card>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
      <!-- latest jquery-->
   </div>
</template>

<style scoped>
.login-card {
   background-size: cover;
}
</style>